const USGS = () => {
  const Gages = {
    'below-cherry-creek-lake': '06713000',
    'near-parker': '393109104464500',
    'near-franktown': '06712000',
  };
  

  const StartDate = new datePicker({
    container: '#start-date',
    elementExists: true,
    onChange: (e) => {
      updateIframe();
    },
  });

  const EndDate = new datePicker({
    container: '#end-date',
    elementExists: true,
    onChange: (e) => {
      updateIframe();
    },
  });

  const GageChips = new chipBag({
    parentContainer: '.usgs-gages-chips',
    elementExists: false,
    chipActiveColor: '#2196F3',
    singleSelect: true,
    data: [
      { value: 'below-cherry-creek-lake', display: 'Below Cherry Creek Lake' },
      { value: 'near-parker', display: 'Near Parker' },
      { value: 'near-franktown', display: 'Near Franktown' },
    ],
    onChange: (e) => {
      GageChips.val(e);
      const gage = GageChips.activeChips[0].chipValue;
      toggleIframeDislay(gage);
    }
  });

  function formatDate(date) {
    return date.replace(/-/g, '');
  }

  function toggleIframeDislay(gage) {
    const iframes = document.querySelectorAll('.chips-data-nav-section');
    const activeIframe = document.querySelector(`#${gage}`);
    iframes.forEach(iframe => iframe.style.display = 'none');
    activeIframe.style.display = 'block';
  }

  function createIframeSrc(src,startDate,EndDate) {
    let updatedSrc = src;
    updatedSrc += "&begin_date="+formatDate(startDate);
    updatedSrc += "&end_date="+formatDate(EndDate);
    return updatedSrc;
  }

  function updateIframe() {
    const iframes = document.querySelectorAll('.chips-data-nav-section iframe');
    iframes.forEach((iframe) => {
      const src = iframe.getAttribute("src").split('&');
      const baseSrc = src[0] + '&' + src[1] + '&' + src[2];
      const newSrc = createIframeSrc(baseSrc, StartDate.getDate(), EndDate.getDate()); 
      iframe.setAttribute('src', newSrc);
    });
  }

  GageChips.buildChips();
  GageChips.chips.filter(chip => chip.chipValue === 'near-parker')[0].toggleState(true);

  StartDate.setDate('2017-10-01');
  EndDate.setDate('2018-09-30');

  const FlowProportions = new Pie({
    container: '#flow-pie-chart',
    widthScale: 1,
    heightScale: 1,
    innerRadius: 80,
    resultField: 'rvalue',
    categoryField: 'location',
    data: [
      { location: 'Cherry Creek', rvalue: 83.6 },
      { location: 'Cottonwood Creek', rvalue: 16.4 },
    ],
  }).draw();
  
};
